import _extends from "@babel/runtime/helpers/extends";
import { ProductHat as ProductHatUI } from '@wix/premium-purchase-platform/@ui';
import React from 'react';
import { useProductHat } from '../../hooks';
export const ProductHat = _ref => {
  let {
    productId,
    textWeight,
    borderRadius,
    height
  } = _ref;
  const {
    text,
    background,
    hasHat
  } = useProductHat({
    productId
  });
  if (!hasHat) {
    return null;
  }
  return /*#__PURE__*/React.createElement(ProductHatUI, _extends({
    hatText: text,
    textWhite: false,
    background: background,
    width: "100%"
  }, textWeight && {
    textWeight
  }, borderRadius && {
    borderRadius
  }, height && {
    height
  }));
};
//# sourceMappingURL=ProductHat.js.map